import React from 'react';
import { btnStyle } from '../PlateStyles';
import { formatirajDatumSRB } from '../PlateUtils';

const AddRowModal = ({ newRowDate, setNewRowDate, onAdd, onClose }) => {
    const containerStyle = {
        position: 'relative',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#162447',
        border: '1px solid #17a2b8',
        height: '45px',
        borderRadius: '4px',
        cursor: 'pointer'
    };

    const inputDateStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        opacity: 0, // Nevidljiv ali pokriva celu površinu za klik
        cursor: 'pointer',
        zIndex: 2
    };

    const textOverlayStyle = {
        color: 'white',
        fontSize: '18px',
        pointerEvents: 'none',
        zIndex: 1
    };

    return (
        <div style={{position: 'fixed', top:0, left:0, width:'100%', height:'100%', backgroundColor:'rgba(0,0,0,0.9)', display:'flex', justifyContent:'center', alignItems:'center', zIndex: 9999}}>
            <div style={{backgroundColor:'#0a132b', padding:'30px', borderRadius:'10px', width:'450px', border:'1px solid #17a2b8'}}>
                <h3 style={{color: 'white', marginBottom: '10px'}}>Dodaj novi red</h3>
                <p style={{color: 'white', fontSize: '14px', marginBottom: '15px'}}>Izaberite datum:</p>
                
                <div style={{marginBottom:'25px'}}>
                    <div style={containerStyle}>
                        <input 
                            type="date" 
                            value={newRowDate} 
                            onChange={(e) => setNewRowDate(e.target.value)} 
                            style={inputDateStyle}
                            onClick={(e) => e.target.showPicker && e.target.showPicker()} 
                        />
                        <div style={textOverlayStyle}>
                            {formatirajDatumSRB(newRowDate)}
                        </div>
                    </div>
                </div>

                <button onClick={onAdd} style={{...btnStyle, backgroundColor: '#17a2b8', color: 'white'}}>Dodaj</button>
                <button onClick={onClose} style={{background: 'none', color: 'white', border: 'none', marginLeft: '10px', cursor: 'pointer'}}>Zatvori</button>
            </div>
        </div>
    );
};

export default AddRowModal;